import { PersonalItemBaseDirective } from '$core/base/_personal-item.component';
import { AddressesService } from '$core/services/addresses.service';
import { AuthenticationService } from '$core/services/auth.service';
import { SwalService } from '$core/shell/swal/swal.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { POSTAL_TYPE_MAP } from '../../metadata';
import { BatchShort, Selectable } from '../../models';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-batch-item',
  templateUrl: './batch-item.component.html',
  styleUrls: ['./batch-item.component.scss'],
})
export class BatchItemComponent extends PersonalItemBaseDirective<any> {
  @Input() public item: Selectable<BatchShort>;
  @Input() public compact = false;
  @Output() public toggleSelect = new EventEmitter();

  public readonly POSTAL_TYPE_MAP = POSTAL_TYPE_MAP;
  public readonly dayjs = dayjs;

  constructor(
    public readonly authService: AuthenticationService,
    protected readonly requestService: AddressesService,
    protected readonly modalService: BsModalService,
    protected readonly swalService: SwalService,
    protected readonly translates: TranslateService
  ) {
    super(authService, requestService, modalService, swalService, translates);
  }

  public triggerSelect(): void {
    this.toggleSelect.emit();
  }
}
